import omit from 'lodash/omit';
import unionBy from 'lodash/unionBy';
import { HttpClient } from 'api/http-client';
export var TemplateState = /*#__PURE__*/ function(TemplateState) {
    TemplateState["Draft"] = "DRAFT";
    TemplateState["Published"] = "PUBLISHED";
    return TemplateState;
}({});
export var TemplateSourceType = /*#__PURE__*/ function(TemplateSourceType) {
    TemplateSourceType["Template"] = "TEMPLATE";
    return TemplateSourceType;
}({});
export var TemplateIdType = /*#__PURE__*/ function(TemplateIdType) {
    TemplateIdType["Number"] = "number";
    TemplateIdType["New"] = "new";
    return TemplateIdType;
}({});
export var TemplateObjectType = /*#__PURE__*/ function(TemplateObjectType) {
    TemplateObjectType["Document"] = "DOCUMENT";
    TemplateObjectType["Project"] = "PROJECT";
    TemplateObjectType["Milestone"] = "MILESTONE";
    TemplateObjectType["Task"] = "TASK";
    TemplateObjectType["StatusUpdates"] = "STATUS_UPDATE";
    TemplateObjectType["Form"] = "FORM";
    TemplateObjectType["Automations"] = "AUTOMATIONS";
    TemplateObjectType["BillingSchedule"] = "BILLING_SCHEDULE";
    TemplateObjectType["Sheets"] = "SHEETS";
    TemplateObjectType["ResourceAllocation"] = "RESOURCE_ALLOCATION";
    return TemplateObjectType;
}({});
const NAMESPACE = '/templates';
export class TemplatesHttpClient extends HttpClient {
    getAllTemplates() {
        return this.getStatusUpdateTemplates().then(async (statusTemplates)=>{
            const templates = await this.get(NAMESPACE);
            // only Status update templates returns an extra key, enableAutoPublish.
            // Now we're decorating the response, so that this can be maintained easily.
            const decoratedTemplates = unionBy(statusTemplates, templates, 'templateId');
            return decoratedTemplates;
        });
    }
    async getUserCreatedTaskTemplates() {
        const templates = await this.get(`${NAMESPACE}/tasks/get-user-created`);
        return templates;
    }
    getStatusUpdateTemplates() {
        return this.get(`${NAMESPACE}/status-updates`);
    }
    getStatusUpdateNextPublish(templateId) {
        return this.get(`${NAMESPACE}/${templateId}/next-publish-at`);
    }
    getById(templateId) {
        return this.get(`${NAMESPACE}/${templateId}`);
    }
    deleteById(templateId) {
        return this.delete(`${NAMESPACE}/${templateId}`);
    }
    create(template) {
        return this.post(`${NAMESPACE}`, omit(template, 'templateId'));
    }
    cloneById(templateId) {
        return this.post(`${NAMESPACE}/${templateId}/clone`, {
            templateId
        });
    }
    save(template) {
        if (template.templateId === 'new') {
            return this.create(template);
        }
        return this.put(`${NAMESPACE}/${template.templateId}`, template);
    }
    wipe(templateId) {
        return this.delete(`${NAMESPACE}/${templateId}`);
    }
    preview(template) {
        return this.post(`${NAMESPACE}/project-preview`, template);
    }
    getDueDate({ templateId, ...restPayload }) {
        return this.post(`${NAMESPACE}/${templateId}/get-due-date`, restPayload);
    }
    getTemplateDependenciesMap(payload) {
        return this.post(`${NAMESPACE}/dependency-map`, payload);
    }
}
export const TemplatesAPI = new TemplatesHttpClient();
